import { render, staticRenderFns } from "./FormNotes.vue?vue&type=template&id=6432aef7&scoped=true"
import script from "./FormNotes.vue?vue&type=script&lang=js"
export * from "./FormNotes.vue?vue&type=script&lang=js"
import style0 from "./FormNotes.vue?vue&type=style&index=0&id=6432aef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432aef7",
  null
  
)

export default component.exports